import { render, staticRenderFns } from "./SectionEnergyPrices.vue?vue&type=template&id=e61d22b2&"
import script from "./SectionEnergyPrices.vue?vue&type=script&lang=js&"
export * from "./SectionEnergyPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e61d22b2')) {
      api.createRecord('e61d22b2', component.options)
    } else {
      api.reload('e61d22b2', component.options)
    }
    module.hot.accept("./SectionEnergyPrices.vue?vue&type=template&id=e61d22b2&", function () {
      api.rerender('e61d22b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reports/SectionEnergyPrices.vue"
export default component.exports